import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  return (
    <section id="home" className={`hero ${isDarkMode ? 'hero-dark' : 'hero-light'}`} ref={heroRef}>
      {/* Background pattern overlay */}
      <div className="hero-pattern-overlay"></div>
      
      <div className="hero-image-container">
        <div className={`hero-logo-wrapper ${isVisible ? 'animate-fade-in' : ''}`}>
          <img 
            src="/images/no backround.png" 
            alt="E-Q.O.L. Logo" 
            className="hero-main-image"
            onError={(e) => {
              // Fallback to theme background if image fails to load
              e.target.style.display = 'none';
              e.target.parentElement.style.background = 'var(--bg-primary)';
            }}
          />
        </div>
      </div>
      
      <div className={`hero-content ${isVisible ? 'animate-slide-up' : ''}`}>
        <div className="hero-text">
          <div className="hero-tagline">
          </div>
          <p className="hero-description">
            Join us in creating a more inclusive world where everyone has equal opportunities 
            to thrive and succeed in all aspects of life.
          </p>
        </div>
        <div className="hero-actions">
          <Link to="/contact" className="btn btn-primary hero-btn">
            Contact Us
          </Link>
          <Link to="/get-involved" className="btn btn-secondary hero-btn">
            Join Our Team
          </Link>
          <Link to="/about" className="btn btn-outline hero-btn">
            Learn More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
